import { Box, CardMedia, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import ImagenNotFound from "../../../images/Imagen_not_found.png";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import AddBoxIcon from '@mui/icons-material/AddBox';
import RemoveBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import DeleteIcon from '@mui/icons-material/Delete';

export const ArticuloKioskCard = ({ item, isBarcode, tieneObs = false, onClickImg, onIncrease, onDecrease, onEdit, onDelete }) => {
  const theme = useTheme();
  const idProducto = item.idArticulo;
  const codigo = item.codigo;
  const descripcion = item.descripcion;
  const precio = item.precioUnitario;
  const imageSource = item.imagen;

  const [quantity, setQuantity] = useState(item.cantidadArticulo);

  // Sincronizar el estado local con las props cuando cambie item.cantidadArticulo
  useEffect(() => {
    setQuantity(item.cantidadArticulo);
  }, [item.cantidadArticulo]);

  const noSelectStyle = {
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    msUserSelect: "none",
  };

  const handleIncrease = (event) => {
    event?.stopPropagation();
    if ((item && item.comandaDetalleElementos.length === 0) || isBarcode) {
      const nuevaCantidad = quantity + 1;
      setQuantity(nuevaCantidad);
      onIncrease(nuevaCantidad);
    } else {
      onIncrease(quantity);
    }
  };

  const handleDecrease = (event) => {
    event?.stopPropagation();
    if (quantity > 0) {
      const nuevaCantidad = quantity - 1;
      setQuantity(nuevaCantidad);
      onDecrease(nuevaCantidad);
    }
  };

  const handleDelete = (event) => {
    event?.stopPropagation();
    onDelete();
    setQuantity(0);
  };

  const getColorByEstadoLocacion = estado => {
    switch (estado) {
      case 0:
        return "#FFE4B5";
      case 1:
        return "#ADD8E6";
      case 2:
        return "#90EE90";
      case -1:
        return "#FFB6C1";
      default:
        return "#FFFFFF";
    }
  };
  const estado = item?.pedidosProductosALocacion?.estado || undefined;
  const stripeColor = getColorByEstadoLocacion(estado);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        border: `3px solid ${quantity>0 ? theme.bandera.colorSecundario : '#fff'}`,
        borderRadius: "4px",
        p: 2,
        margin: 1,
        width: 190,
        height: 300,
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
      }}
      onClick={() => quantity === 0 && handleIncrease()}
    >
      {/* Precio */}
      <Box sx={{ textAlign: "right", alignSelf: "flex-end", mb: 1 }}>
        <Typography sx={{ fontWeight: "bold", fontSize: 16, color: quantity===0? '#000' : theme.bandera.colorSecundario }}>
          {quantity <= 1 ? `$${precio.toLocaleString("es-Ar")}` : `$${(precio * quantity).toLocaleString("es-Ar")}`}
        </Typography>
      </Box>
      
      {/* Imagen */}
      <CardMedia
        key={idProducto}
        component="img"
        image={imageSource || ImagenNotFound}
        sx={{
          width: "100%",
          height: "150px",
          borderRadius: "8px",
          objectFit: "contain",
          backgroundColor: "#fff",
          mb: 1,
        }}
      />
      
      {/* Descripción - Área flexible que se expande */}
      <Box sx={{ 
        flex: 1, 
        display: "flex", 
        alignItems: "flex-start", 
        justifyContent: "center",
        width: "100%",
        mb: 1,
        overflow: "hidden"
      }}>
        <Typography 
          fontSize={10} 
          color="textSecondary"
          sx={{
            textAlign: "center",
            display: "-webkit-box",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }}
        >
          {descripcion}
        </Typography>
        {/* Mostrar descripcionPersonalizada si existe, sino mostrar comentarios */}
        {/* {item && (item.descripcionPersonalizada || item.comentarios) && (
                <Typography fontSize={10} color="textSecondary">
                  Obs. {item.descripcionPersonalizada || item.comentarios}
                </Typography>
              )} */}
      </Box>

      {/* Botones - Siempre en la parte inferior */}
      <Box sx={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between",
        width: "100%",
        mt: "auto" // Esto empuja los botones hacia abajo
      }}>
        <DeleteIcon
          sx={{ fontSize: 25, color: quantity === 0 ? "darkgray" : theme.bandera.colorSecundario }}
          onClick={handleDelete}
          disabled={quantity === 0}
        />
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <RemoveBoxIcon
            sx={{ fontSize: 30, color: quantity === 0 ? "darkgray" : theme.bandera.colorSecundario }}
            onClick={handleDecrease}
            disabled={quantity === 0}
          />
          <Typography fontSize={12} sx={{ mx: 1 }}>
            {quantity}
          </Typography>
          <AddBoxIcon sx={{ fontSize: 30, mr: 1, color: theme.bandera.colorSecundario }} onClick={handleIncrease} />
        </Box>
        {/* <EditIcon
          sx={{ fontSize: 20, mr: 1, color: quantity !== 0 ? (tieneObs ? theme.bandera.colorSecundario : "#7d7d7d") : "darkgray" }}
          onClick={() => {
            quantity !== 0 && onEdit();
          }}
          disabled={quantity === 0}
        /> */}
        {/* <CopyrightIcon sx={{ fontSize: 18, mr: -1.5, color: theme.bandera.colorSecundario  }} onClick={handleDelete}/> */}
      </Box>
    </Box>
  );
};
